const GBP_COUNTRIES = ["UK", "GB"];
const CHF_COUNTRIES = ["CH"];
const SERVICE_ADJUSTMENT_DISABLED_COUNTRIES = ["CH", "PL"];
const EXTRAP_TYPE_SELECTION_DISABLED_COUNTRIES = ["PL"];

export function getCurrencyCode(countryCode) {
    if (GBP_COUNTRIES.includes(countryCode)) return "GBP";
    if (CHF_COUNTRIES.includes(countryCode)) return "CHF";
    if (countryCode === "PL") return "PLN";
    return "EUR";
}

export function getCurrencySymbol(countryCode) {
    if (GBP_COUNTRIES.includes(countryCode)) return "£";
    if (CHF_COUNTRIES.includes(countryCode)) return "CHF";
    return "€";
}

export function getCurrencyLabel(countryCode) {
    const code = getCurrencyCode(countryCode);
    return code ? `| ${code}` : "";
}

export function getCurrencySymbolByCountryName(countryName) {
    if (countryName === "United Kingdom") return "£";
    if (countryName === "Switzerland") return "CHF";
    return "€";
}

export function isServiceAdjustmentEnabled(countryCode) {
    return !SERVICE_ADJUSTMENT_DISABLED_COUNTRIES.includes(countryCode);
}

export function isExtrapTypeSelectionEnabled(countryCode) {
    return !EXTRAP_TYPE_SELECTION_DISABLED_COUNTRIES.includes(countryCode);
}
